<template>
	<div id="formTicket">
		<i class="fas fa-plus-circle float-right text-primary pointer" data-toggle="modal" data-target="#formTicketModal"></i>
		<div class="modal fade" id="formTicketModal" tabindex="-1" role="dialog" aria-labelledby="formTicketModalLabel" aria-hidden="true">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="formTicketModalLabel">
							<i class="fas fa-ticket-alt"></i> 
							Nuevo Ticket
						</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="form-group">
							<label for="subject">Asunto</label>
							<input type="text" class="form-control" id="subject" aria-describedby="asuntoHelp" placeholder="Ingrese el asunto aquí" v-model="objectTicket.subject">
						</div>
						<div class="form-group">
							<label for="description">Descripción</label>
							<textarea class="form-control" id="description" rows="3"  v-model="objectTicket.message"></textarea>
						</div>
						<div class="form-group">
							<label for="receiver">Destinatario</label>
							<select class="form-control" id="receiver"  v-model="objectTicket.receiverId">
								<optgroup label="Departamentos">
									<option v-for="item in listDepartments" :value="'D-' + item.id">{{ item.name }}</option>
								</optgroup>
								<optgroup label="Usuarios">
									<option v-for="item in listUsers" :value="'U-' + item.id">{{ item.name }}</option>
								</optgroup>
							</select>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal" ref="closeFormTicketModal">Cerrar</button>
						<button type="button" class="btn btn-primary" @click="save">Guardar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import department from '@/mixins/departments'
	import user from '@/mixins/users'
	import ticket from '@/mixins/tickets'

	export default {
		mixins: [axiosAction, errors, mixin, department, user, ticket],
		data () {
			return {
			}
		},
		computed: {
		},
		methods: {
			initComponent() {
				this.getAllUsers()
				this.getAllDepartments()
			},
			resultAxiosLocal(responseLocal, response) {
				switch(responseLocal) {
					case 'resultgetAllDepartments': this.listDepartments = response.data.data; break;
					case 'resultgetAllUsers': this.listUsers = response.data.data; break;
				}
				this.$emit('hideLockScreen')
			},
			save() {
				this.$refs.closeFormTicketModal.click()
				setTimeout(() => this.$emit('saveTicketFromModal', this.objectTicket), 500)
			},
		},
		mounted () {
			this.initComponent()
		}
	}
</script>

<style scoped lang="scss">
</style>
